export default __webpack_public_path__ + "static/media/lOGO2.1f85c50d.png";